import React, { Component } from "react";
import purifyHTML from "../../../utils/purifyHTML";

export default class FieldWrapper extends Component {
  constructor() {
    super();
    this.state = {
      focused: false,
    };
  }
  render() {
    const { config, showErrors, errorMessage, isRequired } = this.props;
    const { focused } = this.state;
    const {
      label,
      labelInInput,
      labelHidden,
      hint,
      transparent,
      readOnly,
      disabled,
      name,
      class: className,
      explanation,
    } = config;

    return (
      <div
        className={`
          field 
          ${transparent ? "field--transparent" : ""}
          ${isRequired ? "field--required" : ""} 
          ${showErrors ? "field--has-errors" : ""}
          ${readOnly ? "field--readonly" : ""}
          ${disabled ? "field--disabled" : ""}
          ${focused ? "focus-within" : ""}
          ${className ? className : ""}
          js-text-field
        `}
      >
        {!labelInInput && label ? (
          <label
            className={`field__label ${labelHidden ? "sr-only" : ""}`}
            htmlFor={name}
          >
            {label}
          </label>
        ) : null}
        {hint ? (
          <div
            className="field__hint"
            dangerouslySetInnerHTML={purifyHTML(hint)}
          ></div>
        ) : null}
        {this.renderField()}
        {showErrors && errorMessage && (
          <div
            className="field__error"
            role="alert"
            dangerouslySetInnerHTML={purifyHTML(errorMessage)}
          />
        )}
        {explanation && <div className="field__explanation">{explanation}</div>}
      </div>
    );
  }

  renderField() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/FieldWrapper.js